import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from "rxjs";
import {CatUser} from "@catcore/types/api-v2";

export enum ROLE {
  USER = 'ROLE_USER',
  ADMIN = 'ROLE_ADMIN',
  MODEL_EDIT = 'ROLE_MODEL_EDIT',
  FEATURE_EDIT = 'ROLE_FEATURE_EDIT',
  PROJECT_EDIT = 'ROLE_PROJECT_EDIT'
}

@Injectable()
export class UserService {

  public BASE = '/api';
  private subject = new Subject();
  private data$ = this.subject.asObservable();
  private rawUser: Object = null;
  private user: CatUser = null;

  constructor(private http: HttpClient) {
  }

  refresh() {
    this.http
      .get(`${this.BASE}/users/me`)
      .subscribe((user: any) => {
        this.setUser(user);
      });
  }


  setUser(user) {
    this.rawUser = user;

    if (user !== null) {
        let roles: ROLE[] = [];
        user['_links']['user_roles'].forEach((r: Object) => {
            let roleName: string = r['label'];
            if (ROLE[roleName.replace('ROLE_','')]) {
                roles.push(ROLE[roleName.replace('ROLE_','')]);
            }
        });

        this.user = {
            name: user.name,
            roles: roles,
            hasRole: (role: ROLE) => {
                return roles.includes(role);
            }
        };
    }

    this.subject.next(this.user);
  }

    /**
     * Returns the last fetched (i.e. logged-in user)
     * If not fetched yet it returns null. Use getUser() and refresh().
     *
     * @return CatUser|null
     */
  getCurrentUser() {
      if (this.user !== null) {
          return this.user;
      }
      // Shouldn't ever happen as our navigation bar fetches the user..
      console.warn('Call refresh() and use getUser() observable for initial user fetching');
      return null;
  }

  getUser() {
      return this.data$;
  }

  logout() {
    this.http
          .get(`${this.BASE}/logout`)
          .catch((err) => {
            this.setUser(null);
            this.refresh();
            return Observable.of(null);
          })
          .subscribe(() => {
              // no-op
          });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/services/user.service.ts